// eslint-disable-next-line import/prefer-default-export
export const siteKey = process.env.REACT_APP_GOOGLE_SITE_KEY || '';
